import { render, staticRenderFns } from "./UI-language-bar-icon.vue?vue&type=template&id=d212e608&"
import script from "./UI-language-bar-icon.vue?vue&type=script&lang=js&"
export * from "./UI-language-bar-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports